import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/footer-logo.png";
import FacebookIcon from "../assets/facebook.png";
import InstagramIcon from "../assets/instragarm.png";
import LinkedinIcon from "../assets/linkedin.png";

const SOCIAL_LINKS = [
  {
    icon: FacebookIcon,
    label: "Facebook",
    href: "https://www.facebook.com/STEAMMINDS",
  },
  {
    icon: InstagramIcon,
    label: "Instagram",
    href: "https://www.instagram.com/steam.minds/",
  },
  {
    icon: LinkedinIcon,
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/steam-minds/?viewAsMember=true",
  },
  { icon: null, label: "X", href: "https://x.com/STEAM_Minds", isX: true },
];

const FOOTER_LINKS = [
  {
    heading: "Categories",
    links: [
      { label: "Science" },
      { label: "Technology" },
      { label: "Engineering" },
      { label: "Arts" },
      { label: "Mathematics" },
    ],
  },
  {
    heading: "Support",
    links: [
      { label: "Help Centre" },
      { label: "FAQs" },
      { label: "Terms & Conditions" },
      { label: "Privacy Policy" },
    ],
  },
  {
    heading: "Company",
    links: [
      { label: "Contact Us", to: "/contact-us" },
      { label: "About Us", to: "/about-us" },

      { label: "Blog", to: "" },
    ],
  },
];

const Footer = () => {
  return (
    <div className="bg-[#FF6636] py-8">
      <div className="mx-auto w-full max-w-[1774px] text-white px-6 sm:px-8 lg:px-10">
        <div className="flex flex-col lg:flex-row justify-between gap-16 lg:gap-32">
          <div className="flex w-full max-w-[122px] shrink-0 flex-col items-center ">
            <img src={Logo} alt="logo" className="w-[70px] h-[90px]" />
            <h1 className="font-semibold mt-2 md:mt-4  text-center tracking-[-0.4%] text-xl leading-[26px]">
              Empowering Young Minds!
            </h1>
          </div>

          <div className="lg:mt-4 w-full max-w-[838px] flex justify-between gap-y-8 gap-x-14 flex-col min-[500px]:flex-row">
            {FOOTER_LINKS.map((col, idx) => (
              <div key={idx} className="min-w-0">
                <h2 className="font-semibold text-lg tracking-[-0.4%] leading-[26px]">
                  {col.heading}
                </h2>
                <ul className="mt-3 flex flex-col gap-0.5 sm:gap-[5px] font-bold text-sm leading-[26px]">
                  {col.links.map(({ label, to }, i) => (
                    <li key={i}>
                      {to ? (
                        <Link
                          to={to}
                          className="transition-opacity hover:opacity-80"
                        >
                          {label}
                        </Link>
                      ) : (
                        label
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="lg:mt-8 flex  shrink-0 flex-col ">
            <h2 className="font-bold  leading-[26px]">Follow Us On</h2>
            <div className="mt-3 md:mt-5 flex gap-2 sm:gap-3">
              {SOCIAL_LINKS.map(({ icon, label, href, isX }) => (
                <a
                  href={href}
                  key={label}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-[46px] h-[46px] bg-white  flex items-center justify-center cursor-pointer"
                >
                  {isX ? (
                    <svg
                      viewBox="0 0 24 24"
                      className="w-[18px] h-[18px]"
                      fill="#FF6636"
                    >
                      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.747l7.73-8.835L1.254 2.25H8.08l4.253 5.622L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z" />
                    </svg>
                  ) : (
                    <img src={icon} alt={label} className="w-[18px] h-[18px]" />
                  )}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
